<app-slide-overlay-header
  [canDelete]="hasEntitiesWriteAccess"
  [canArchive]="hasEntitiesWriteAccess"
  [enableTags]="isRegularUser"
  [initialTags]="initialTags"
  [title]="title()"
  icon="docs"
></app-slide-overlay-header>
<app-slide-overlay-content #slideOverlayContent>
  <ng-template
    [overlay-menu-tab]="overlayTabEnum.DETAILS"
    appSlideOverlayMenuItem
    overlay-menu-icon="info"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.DETAILS).title"
  >
    <app-form-field-group [name]="mainInformationText">
      <app-purchase-order-main-information
        [formGroup]="formGroup"
        [organisationsOptions]="organisationsOptions()"
        [activeOrganisationOption]="activeOrganisationOption()"
        [locationsOptions]="locationsOptions()"
        [element]="element"
        [countryOptions]="countryOptions()"
        (updateBuyerOrganisation)="updateBuyerOrganisation($event)"
        (updateSupplierOrganisation)="updateSupplierOrganisation($event)"
        (updateDeliverToLocation)="updateDeliverToLocation($event)"
      ></app-purchase-order-main-information>
    </app-form-field-group>
    @if (element && isRegularUser && overlay.viewMode()) {
      <app-form-field-group [name]="recordDetailsText">
        <app-record-details [element]="element"></app-record-details>
      </app-form-field-group>
    }
  </ng-template>

  <ng-template
    [overlay-menu-buttons-template]="orderItemController"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.ITEMS).isEnabled"
    [overlay-menu-indicator]="purchaseOrdersOverlayService.lineItemsCount()"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.ITEMS).title"
    [overlay-menu-tooltip]="menuItems().get(overlayTabEnum.ITEMS).tooltip"
    [overlay-menu-tab]="overlayTabEnum.ITEMS"
    appSlideOverlayMenuItem
    overlay-menu-icon="package_2"
  >
    <article class="field-group-container">
      <app-line-items-table
        [rowData]="element?.lineItems"
        (removeLineItem)="onRemoveLineItem($event)"
        (lineItemUpdated)="onLineItemUpdated()"
        [areButtonsEnabled]="element?.status === purchaseOrderStatusEnum.OPEN"
      ></app-line-items-table>
    </article>
  </ng-template>
  <ng-template
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.DELIVERIES).isEnabled"
    [overlay-menu-indicator]="purchaseOrdersOverlayService.deliveriesCount()"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.DELIVERIES).title"
    [overlay-menu-tab]="overlayTabEnum.DELIVERIES"
    appSlideOverlayMenuItem
    overlay-menu-icon="local_shipping"
  >
    <article class="field-group-container">
      <app-deliveries-table
        [columns]="['recordState', 'deliveryId', 'sent', 'from.name', 'to.name']"
        [deliveriesIds]="deliveriesIds()"
      ></app-deliveries-table>
    </article>
  </ng-template>
  <ng-template
    [overlay-menu-buttons-template]="documentController"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.DOCUMENTS).isEnabled"
    [overlay-menu-indicator]="purchaseOrdersOverlayService.documentCounter()"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.DOCUMENTS).title"
    [overlay-menu-tab]="overlayTabEnum.DOCUMENTS"
    appSlideOverlayMenuItem
    overlay-menu-icon="docs"
  >
    <app-overlay-document-attachments
      #documentSection
      [attachmentTargetId]="element?.id"
      [attachmentTargetType]="attachmentTargetEnum.PURCHASE_ORDERS"
      [isReadOnly]="isRecordArchived"
      [overlayService]="purchaseOrdersOverlayService"
    ></app-overlay-document-attachments>
  </ng-template>

  <ng-template #orderItemController>
    @if (
      !overlay.contentRightSidePanel() &&
      isRecordActive &&
      hasEntitiesWriteAccess &&
      element?.status === purchaseOrderStatusEnum.OPEN
    ) {
      <app-button [disabled]="overlay.loading()" type="ghost" (pressed)="onAddPurchaseOrderItem()">
        <mat-icon class="action-icon" icon-left>add</mat-icon>
        <ng-container i18n="@@action.add">Add</ng-container>
      </app-button>
    }
  </ng-template>

  <ng-template
    *ngIf="!menuItems().get(overlayTabEnum.COMMENTS).isHidden"
    [overlay-menu-disabled]="!menuItems().get(overlayTabEnum.COMMENTS).isEnabled"
    [overlay-menu-indicator]="purchaseOrdersOverlayService.commentCounter()"
    [overlay-menu-show-edit-button]="false"
    [overlay-menu-show-save-button]="false"
    [overlay-menu-title]="menuItems().get(overlayTabEnum.COMMENTS).title"
    [overlay-menu-tab]="overlayTabEnum.COMMENTS"
    appSlideOverlayMenuItem
    overlay-menu-icon="chat_bubble"
  >
    <article class="field-group-container">
      <app-comments
        (added)="onCommentAdded(purchaseOrdersOverlayService)"
        (deleted)="onCommentDeleted(purchaseOrdersOverlayService)"
        [entityId]="element?.id"
        [entityType]="entityType"
      ></app-comments>
    </article>
  </ng-template>
</app-slide-overlay-content>

<ng-template #documentController>
  @if (!overlay.contentRightSidePanel() && isRecordActive && hasEntitiesWriteAccess) {
    <app-button
      (pressed)="overlay.openSideMenu(documentSection?.attachmentsRightMenu)"
      [disabled]="overlay.loading()"
      type="ghost"
    >
      <mat-icon class="action-icon" icon-left>add</mat-icon>
      <ng-container i18n="@@action.add">Add</ng-container>
    </app-button>
  }
</ng-template>
